export default __webpack_public_path__ + "static/media/sammonlahdenak.com.4bbd8eb4.png";